export function recruit(rest){
	const compornent = {
		data: function(){
			return {
				toggle: false,
				data:  [],
				detail: []
			}
		},
		created: function(){
            const $_this = this;
            axios.get(rest)
                .then(function (response) {
                    $_this.data = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
		},
		methods: {
			open : function(index){
				this.detail = this.data[index];
				this.toggle = true;
			},
			changing: function(){
				const body = document.getElementById('site-body');
				const head = document.getElementById('site-header');
				body.classList.toggle('hidden');
				head.classList.toggle('hidden');
			}
		},
		template:
		`
		<div>
			<ul class="list clearfix">
				<li v-for="(items , index) in data">
					<div class="bg" :style="{ 'background-image': 'url('+items.acf.main+')' }"></div>
                    <p class="title" v-text="items.title.rendered">
				</li>
			</ul>
            <slot></slot>
		</div>
		`
	}
	
	return compornent;
}